import { ParsedUrlQuery } from 'querystring';

import { CAR_SORT_DATA } from '@constants/constants';
import { SortInterface } from '@domain/carRental/results';
import { CAR_RENTAL_FILTER_QUERY_PARAM_KEYS } from '@page/carRental/list/constants';

export const getActiveSortFromQuery = (query): SortInterface => {
  if (!query[CAR_RENTAL_FILTER_QUERY_PARAM_KEYS.SORT]) {
    return CAR_SORT_DATA[0];
  }

  const sort = CAR_SORT_DATA.find(
    (item) => item.id === query[CAR_RENTAL_FILTER_QUERY_PARAM_KEYS.SORT]
  );

  if (!sort) {
    return CAR_SORT_DATA[0];
  }

  return sort;
};

/**
 * Return safely value ( number or string ) from query
 * @param value string | undefined
 * @returns string | number
 */
export const getSafelyValue = (value: string | undefined) => {
  if (!value) {
    return '';
  }

  return isNaN(Number(value)) ? value : Number(value);
};

/**
 * Return safely selected values from query
 * @param query ParsedUrlQuery
 * @param keyName string
 * @returns ListingFilterItemKey[]
 */
export const getSelectedFilterByKeyNameFromQuery = (
  query: ParsedUrlQuery,
  keyName: string
) => {
  const filterVal = query[keyName];

  if (!filterVal) {
    return [];
  }

  if (typeof filterVal === 'string') {
    // Check if the string contains comma, if so split it into an array
    if (filterVal.includes(',')) {
      return filterVal.split(',').map((f) => getSafelyValue(f.trim()));
    }
    return [getSafelyValue(filterVal)];
  }

  return filterVal.map((f) => getSafelyValue(f));
};
